<div [id]="uniqueId" [style.color]="isValid ? 'black' : 'red'" [@wobbleIf]="{value:!isValid, params: {timing: 1, delay: 1}}">{{ outputText }}</div>